"use strict";
module.exports = {
    entityModel: 'job',
    events: {
        JOB_STARTED: 'JOB_STARTED',
        JOB_COMPLETED: 'JOB_COMPLETED',
        JOB_STOPPED: 'JOB_STOPPED',
        JOB_CREATED: 'JOB_CREATED',
        JOB_UPDATED: 'JOB_UPDATED',
        JOB_ACTIVATED: 'JOB_ACTIVATED',
        JOB_DEACTIVATED: 'JOB_DEACTIVATED',
    },
    actions: {
        get: 'v1.job.get',
        list: 'v1.job.list',
        createJob: 'v1.job.createJob',
        startJob: 'v1.job.startJob',
        resetJob: 'v1.job.resetJob',
        stopJob: 'v1.job.stopJob',
        runStandaloneJob: 'v1.job.runStandaloneJob',
        activate: 'v1.job.activate',
        deactivate: 'v1.job.deactivate',
        upsert: 'v1.job.upsert',
        upsertWhenEmpty: 'v1.job.upsertWhenEmpty',
        updateWhenEmpty: 'v1.job.updateWhenEmpty',
        update: 'v1.job.update',
    },
    expectedRunIntervals: {
        300: '300',
        3600: '3600',
        86400: '86400',
        604800: '604800',
        2628000: '2628000',
    },
    statuses: {
        Error: 'Error',
        Success: 'Success',
        Started: 'Started',
        Undetermined: 'Undetermined',
    },
    runs: {
        statuses: {
            Error: 'Error',
            Success: 'Success',
            Started: 'Started',
            Undetermined: 'Undetermined',
        },
    },
};
